import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const getEducation = id => {
  return dispatch => {
    dispatch({ type: "GET_EDUCATION_LOADING" });
    api
      .educationGet(id)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "FetchEducationErrorAlertTitle",
          "Virhe tutkinnon lukemisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_EDUCATION_SUCCEEDED",
  payload: { education: data },
});

const operationFail = () => ({
  type: "GET_EDUCATION_FAIL",
});
